export default __webpack_public_path__ + "static/media/energy.2384b13e.svg";